import React from 'react';
import './style.css';
import carteiracell from '../../assets/carteiracell.png';

// URL oficial do validador de assinatura digital do Governo (ITI/gov.br).
const GOV_VALIDAR_URL = 'https://validar.iti.gov.br/';

const CardValidarGov = () => {
  return (
    <section className="govv-section">
      <div className="govv-container">

        {/* Lado esquerdo: mockup da carteirinha */}
        <div className="govv-visual">
          <img src={carteiracell} alt="Carteira de estudante UEN no celular" className="govv-img" />
        </div>

        {/* Lado direito: chamada + gov.br + botão */}
        <div className="govv-content">
          <h2 className="govv-title">
            <span className="govv-title-hl">Valide a sua carteira UEN</span> no site gov.br
          </h2>

          {/* Marca gov.br (wordmark colorida) */}
          <div className="govv-brand" aria-label="gov.br">
            <span className="govv-g">g</span>
            <span className="govv-o">o</span>
            <span className="govv-v">v</span>
            <span className="govv-dot">.br</span>
          </div>

          <p className="govv-sub">use o seu código de uso</p>

          <a
            className="govv-btn"
            href={GOV_VALIDAR_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Clique aqui para validar
          </a>
        </div>

      </div>
    </section>
  );
};

export default CardValidarGov;
